import classes from './IconContainerDash.module.scss';

const IconContainerDash = ({iconText}) => {

    let bgColor;
    let iconName;
    let color;
    switch(iconText) {
        case('auctionSchedule'):
            bgColor = '#F97066'
            iconName = 'fa fa-list-check'
            color = 'white'
            break;
        case('favorites'):
            bgColor = '#F6AC3D'
            iconName = 'fas fa-heart'
            color = 'white'
            break;

        case('auction'):
            bgColor = '#292D32'
            iconName = 'fas fa-car-on'
            color = 'white'
            break;

        case('inspection'):
            bgColor = '#47CD89'
            iconName = 'far fa-rectangle-list'
            color = 'white'
            break;

        case('purchases'):
            bgColor = '#F63D68'
            iconName = 'fas fa-bag-shopping'
            color = 'white'
            break;
        default:
            bgColor = 'black'
            iconName = 'fas fa-gavel'
            color = 'black'
    }

    return (
        <div className={classes.IconContainerDash} style={{background: bgColor, color: color}}>
            <i className={iconName}></i>
        </div>
    )
}

export default IconContainerDash;